import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import Hub from "../types/hub";
import { getCompany } from "./company";

interface HubState {
  hubList: Hub[];
  status: "idle" | "loading" | "failed";
}

const initialState: HubState = {
  hubList: [],
  status: "idle",
};

export const getHubInstances = createAsyncThunk<Hub[]>(
  "hub/fetch-all",
  async () => {
    const response = await http.get<Hub[]>("/hub-instance");
    return response.data;
  }
);

const hubSlice = createSlice({
  name: "hub",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHubInstances.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHubInstances.fulfilled, (state, action) => {
        state.status = "idle";
        state.hubList = action.payload;
      })
      .addCase(getHubInstances.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getCompany.fulfilled, (state, action) => {
        if (!action.payload) {
          state.hubList = initialState.hubList;
        }
      });
  },
});

export default hubSlice.reducer;
